/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// @ts-ignore
import type { ConfigurationParameters } from '../configuration';
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from '../configuration';
// @ts-ignore
import type { AxiosError, AxiosResponse } from 'axios';
import {
    useQuery,
    UseMutationOptions,
    useMutation,
    UseQueryOptions
    // @ts-ignore
} from 'react-query';
// @ts-ignore
import { useAuthorizationToken, useAuthQueryKey, useApiBasePath } from '../../utils';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AirlineConfiguration } from '../models';
// @ts-ignore
import { AirportConfiguration } from '../models';
// @ts-ignore
import { AirportConfigurationType } from '../models';
/**
 * AirportConfigurationWebServicesApi - axios parameter creator
 * @export
 */
export const AirportConfigurationWebServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {AirportConfiguration} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration: async (
            airportConfiguration: AirportConfiguration,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'airportConfiguration' is not null or undefined
            assertParamExists('createConfiguration', 'airportConfiguration', airportConfiguration);
            const localVarPath = `/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                airportConfiguration,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfiguration: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteConfiguration', 'uuid', uuid);
            const localVarPath = `/configuration/{uuid}`.replace(`{${'uuid'}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {Array<AirportConfiguration>} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfigurations: async (
            airportConfiguration: Array<AirportConfiguration>,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'airportConfiguration' is not null or undefined
            assertParamExists('deleteConfigurations', 'airportConfiguration', airportConfiguration);
            const localVarPath = `/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                airportConfiguration,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} flightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirlineConfigurationByFlight: async (
            flightId: string,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'flightId' is not null or undefined
            assertParamExists('getAirlineConfigurationByFlight', 'flightId', flightId);
            const localVarPath = `/configuration/{flightId}`.replace(
                `{${'flightId'}}`,
                encodeURIComponent(String(flightId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations: async (
            includeNonActive?: boolean,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            const localVarPath = `/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (includeNonActive !== undefined) {
                localVarQueryParameter['includeNonActive'] = includeNonActive;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {AirportConfigurationType} type
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationsByType: async (
            type: AirportConfigurationType,
            includeNonActive?: boolean,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getConfigurationsByType', 'type', type);
            const localVarPath = `/configurations/{type}`.replace(`{${'type'}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (includeNonActive !== undefined) {
                localVarQueryParameter['includeNonActive'] = includeNonActive;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {Array<AirportConfiguration>} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfigurations: async (
            airportConfiguration: Array<AirportConfiguration>,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'airportConfiguration' is not null or undefined
            assertParamExists('setConfigurations', 'airportConfiguration', airportConfiguration);
            const localVarPath = `/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                airportConfiguration,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {AirportConfiguration} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration: async (
            airportConfiguration: AirportConfiguration,
            options: AxiosRequestConfig = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'airportConfiguration' is not null or undefined
            assertParamExists('updateConfiguration', 'airportConfiguration', airportConfiguration);
            const localVarPath = `/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                airportConfiguration,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * AirportConfigurationWebServicesApi - functional programming interface
 * @export
 */
export const AirportConfigurationWebServicesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = AirportConfigurationWebServicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AirportConfiguration} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConfiguration(
            airportConfiguration: AirportConfiguration,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirportConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConfiguration(
                airportConfiguration,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConfiguration(
            uuid: string,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfiguration(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {Array<AirportConfiguration>} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConfigurations(
            airportConfiguration: Array<AirportConfiguration>,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfigurations(
                airportConfiguration,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {string} flightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAirlineConfigurationByFlight(
            flightId: string,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirlineConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAirlineConfigurationByFlight(
                flightId,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurations(
            includeNonActive?: boolean,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AirportConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurations(includeNonActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {AirportConfigurationType} type
         * @param {boolean} [includeNonActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurationsByType(
            type: AirportConfigurationType,
            includeNonActive?: boolean,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AirportConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurationsByType(
                type,
                includeNonActive,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {Array<AirportConfiguration>} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setConfigurations(
            airportConfiguration: Array<AirportConfiguration>,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AirportConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setConfigurations(airportConfiguration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        },
        /**
         *
         * @param {AirportConfiguration} airportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfiguration(
            airportConfiguration: AirportConfiguration,
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirportConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfiguration(
                airportConfiguration,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        }
    };
};

/**
 * AirportConfigurationWebServicesApi - factory interface
 * @export
 */
export const AirportConfigurationWebServicesApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = AirportConfigurationWebServicesApiFp(configuration);
    return {
        /**
         *
         * @param {AirportConfigurationWebServicesApiCreateConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration(
            requestParameters: AirportConfigurationWebServicesApiCreateConfigurationRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<AirportConfiguration> {
            return localVarFp
                .createConfiguration(requestParameters.airportConfiguration, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiDeleteConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfiguration(
            requestParameters: AirportConfigurationWebServicesApiDeleteConfigurationRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<void> {
            return localVarFp
                .deleteConfiguration(requestParameters.uuid, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiDeleteConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfigurations(
            requestParameters: AirportConfigurationWebServicesApiDeleteConfigurationsRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<void> {
            return localVarFp
                .deleteConfigurations(requestParameters.airportConfiguration, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirlineConfigurationByFlight(
            requestParameters: AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<AirlineConfiguration> {
            return localVarFp
                .getAirlineConfigurationByFlight(requestParameters.flightId, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiGetConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(
            requestParameters: AirportConfigurationWebServicesApiGetConfigurationsRequest = {},
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<AirportConfiguration>> {
            return localVarFp
                .getConfigurations(requestParameters.includeNonActive, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationsByType(
            requestParameters: AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<AirportConfiguration>> {
            return localVarFp
                .getConfigurationsByType(requestParameters.type, requestParameters.includeNonActive, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiSetConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfigurations(
            requestParameters: AirportConfigurationWebServicesApiSetConfigurationsRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<Array<AirportConfiguration>> {
            return localVarFp
                .setConfigurations(requestParameters.airportConfiguration, options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @param {AirportConfigurationWebServicesApiUpdateConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(
            requestParameters: AirportConfigurationWebServicesApiUpdateConfigurationRequest,
            options?: AxiosRequestConfig
        ): AxiosPromise<AirportConfiguration> {
            return localVarFp
                .updateConfiguration(requestParameters.airportConfiguration, options)
                .then(request => request(axios, basePath));
        }
    };
};

/**
 * Request parameters for createConfiguration operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiCreateConfigurationRequest
 */
export interface AirportConfigurationWebServicesApiCreateConfigurationRequest {
    /**
     *
     * @type {AirportConfiguration}
     * @memberof AirportConfigurationWebServicesApiCreateConfiguration
     */
    readonly airportConfiguration: AirportConfiguration;
}

/**
 * Request parameters for deleteConfiguration operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiDeleteConfigurationRequest
 */
export interface AirportConfigurationWebServicesApiDeleteConfigurationRequest {
    /**
     *
     * @type {string}
     * @memberof AirportConfigurationWebServicesApiDeleteConfiguration
     */
    readonly uuid: string;
}

/**
 * Request parameters for deleteConfigurations operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiDeleteConfigurationsRequest
 */
export interface AirportConfigurationWebServicesApiDeleteConfigurationsRequest {
    /**
     *
     * @type {Array<AirportConfiguration>}
     * @memberof AirportConfigurationWebServicesApiDeleteConfigurations
     */
    readonly airportConfiguration: Array<AirportConfiguration>;
}

/**
 * Request parameters for getAirlineConfigurationByFlight operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest
 */
export interface AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest {
    /**
     *
     * @type {string}
     * @memberof AirportConfigurationWebServicesApiGetAirlineConfigurationByFlight
     */
    readonly flightId: string;
}

/**
 * Request parameters for getConfigurations operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiGetConfigurationsRequest
 */
export interface AirportConfigurationWebServicesApiGetConfigurationsRequest {
    /**
     *
     * @type {boolean}
     * @memberof AirportConfigurationWebServicesApiGetConfigurations
     */
    readonly includeNonActive?: boolean;
}

/**
 * Request parameters for getConfigurationsByType operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest
 */
export interface AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest {
    /**
     *
     * @type {AirportConfigurationType}
     * @memberof AirportConfigurationWebServicesApiGetConfigurationsByType
     */
    readonly type: AirportConfigurationType;

    /**
     *
     * @type {boolean}
     * @memberof AirportConfigurationWebServicesApiGetConfigurationsByType
     */
    readonly includeNonActive?: boolean;
}

/**
 * Request parameters for setConfigurations operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiSetConfigurationsRequest
 */
export interface AirportConfigurationWebServicesApiSetConfigurationsRequest {
    /**
     *
     * @type {Array<AirportConfiguration>}
     * @memberof AirportConfigurationWebServicesApiSetConfigurations
     */
    readonly airportConfiguration: Array<AirportConfiguration>;
}

/**
 * Request parameters for updateConfiguration operation in AirportConfigurationWebServicesApi.
 * @export
 * @interface AirportConfigurationWebServicesApiUpdateConfigurationRequest
 */
export interface AirportConfigurationWebServicesApiUpdateConfigurationRequest {
    /**
     *
     * @type {AirportConfiguration}
     * @memberof AirportConfigurationWebServicesApiUpdateConfiguration
     */
    readonly airportConfiguration: AirportConfiguration;
}

/**
 * AirportConfigurationWebServicesApi - object-oriented interface
 * @export
 * @class AirportConfigurationWebServicesApi
 * @extends {BaseAPI}
 */
export class AirportConfigurationWebServicesApi extends BaseAPI {
    /**
     *
     * @param {AirportConfigurationWebServicesApiCreateConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public createConfiguration(
        requestParameters: AirportConfigurationWebServicesApiCreateConfigurationRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .createConfiguration(requestParameters.airportConfiguration, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiDeleteConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public deleteConfiguration(
        requestParameters: AirportConfigurationWebServicesApiDeleteConfigurationRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .deleteConfiguration(requestParameters.uuid, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiDeleteConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public deleteConfigurations(
        requestParameters: AirportConfigurationWebServicesApiDeleteConfigurationsRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .deleteConfigurations(requestParameters.airportConfiguration, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public getAirlineConfigurationByFlight(
        requestParameters: AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .getAirlineConfigurationByFlight(requestParameters.flightId, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiGetConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public getConfigurations(
        requestParameters: AirportConfigurationWebServicesApiGetConfigurationsRequest = {},
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .getConfigurations(requestParameters.includeNonActive, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public getConfigurationsByType(
        requestParameters: AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .getConfigurationsByType(requestParameters.type, requestParameters.includeNonActive, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiSetConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public setConfigurations(
        requestParameters: AirportConfigurationWebServicesApiSetConfigurationsRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .setConfigurations(requestParameters.airportConfiguration, options)
            .then(request => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {AirportConfigurationWebServicesApiUpdateConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirportConfigurationWebServicesApi
     */
    public updateConfiguration(
        requestParameters: AirportConfigurationWebServicesApiUpdateConfigurationRequest,
        options?: AxiosRequestConfig
    ) {
        return AirportConfigurationWebServicesApiFp(this.configuration)
            .updateConfiguration(requestParameters.airportConfiguration, options)
            .then(request => request(this.axios, this.basePath));
    }
}

// custom hook generation here
export type PostCreateConfigurationResponse = AxiosResponse<AirportConfiguration>;
export const KeyPostCreateConfiguration = 'PostCreateConfiguration';
export const useMutationPostCreateConfiguration = (
    options?: UseMutationOptions<
        PostCreateConfigurationResponse,
        AxiosError,
        AirportConfigurationWebServicesApiCreateConfigurationRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PostCreateConfigurationResponse,
        AxiosError,
        AirportConfigurationWebServicesApiCreateConfigurationRequest
    >(
        (args: AirportConfigurationWebServicesApiCreateConfigurationRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).createConfiguration(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPostCreateConfiguration = (
    args: AirportConfigurationWebServicesApiCreateConfigurationRequest,
    options?: UseQueryOptions<PostCreateConfigurationResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PostCreateConfigurationResponse, AxiosError>(
        [KeyPostCreateConfiguration, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).createConfiguration(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type DeleteDeleteConfigurationResponse = AxiosResponse<void>;
export const KeyDeleteDeleteConfiguration = 'DeleteDeleteConfiguration';
export const useMutationDeleteDeleteConfiguration = (
    options?: UseMutationOptions<
        DeleteDeleteConfigurationResponse,
        AxiosError,
        AirportConfigurationWebServicesApiDeleteConfigurationRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        DeleteDeleteConfigurationResponse,
        AxiosError,
        AirportConfigurationWebServicesApiDeleteConfigurationRequest
    >(
        (args: AirportConfigurationWebServicesApiDeleteConfigurationRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).deleteConfiguration(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryDeleteDeleteConfiguration = (
    args: AirportConfigurationWebServicesApiDeleteConfigurationRequest,
    options?: UseQueryOptions<DeleteDeleteConfigurationResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<DeleteDeleteConfigurationResponse, AxiosError>(
        [KeyDeleteDeleteConfiguration, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).deleteConfiguration(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type DeleteDeleteConfigurationsResponse = AxiosResponse<void>;
export const KeyDeleteDeleteConfigurations = 'DeleteDeleteConfigurations';
export const useMutationDeleteDeleteConfigurations = (
    options?: UseMutationOptions<
        DeleteDeleteConfigurationsResponse,
        AxiosError,
        AirportConfigurationWebServicesApiDeleteConfigurationsRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        DeleteDeleteConfigurationsResponse,
        AxiosError,
        AirportConfigurationWebServicesApiDeleteConfigurationsRequest
    >(
        (args: AirportConfigurationWebServicesApiDeleteConfigurationsRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).deleteConfigurations(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryDeleteDeleteConfigurations = (
    args: AirportConfigurationWebServicesApiDeleteConfigurationsRequest,
    options?: UseQueryOptions<DeleteDeleteConfigurationsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<DeleteDeleteConfigurationsResponse, AxiosError>(
        [KeyDeleteDeleteConfigurations, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).deleteConfigurations(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetAirlineConfigurationByFlightResponse = AxiosResponse<AirlineConfiguration>;
export const KeyGetGetAirlineConfigurationByFlight = 'GetGetAirlineConfigurationByFlight';
export const useMutationGetGetAirlineConfigurationByFlight = (
    options?: UseMutationOptions<
        GetGetAirlineConfigurationByFlightResponse,
        AxiosError,
        AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        GetGetAirlineConfigurationByFlightResponse,
        AxiosError,
        AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest
    >(
        (args: AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getAirlineConfigurationByFlight(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetAirlineConfigurationByFlight = (
    args: AirportConfigurationWebServicesApiGetAirlineConfigurationByFlightRequest,
    options?: UseQueryOptions<GetGetAirlineConfigurationByFlightResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetAirlineConfigurationByFlightResponse, AxiosError>(
        [KeyGetGetAirlineConfigurationByFlight, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getAirlineConfigurationByFlight(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetConfigurationsResponse = AxiosResponse<Array<AirportConfiguration>>;
export const KeyGetGetConfigurations = 'GetGetConfigurations';
export const useMutationGetGetConfigurations = (
    options?: UseMutationOptions<
        GetGetConfigurationsResponse,
        AxiosError,
        AirportConfigurationWebServicesApiGetConfigurationsRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        GetGetConfigurationsResponse,
        AxiosError,
        AirportConfigurationWebServicesApiGetConfigurationsRequest
    >(
        (args: AirportConfigurationWebServicesApiGetConfigurationsRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getConfigurations(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetConfigurations = (
    args: AirportConfigurationWebServicesApiGetConfigurationsRequest,
    options?: UseQueryOptions<GetGetConfigurationsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetConfigurationsResponse, AxiosError>(
        [KeyGetGetConfigurations, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getConfigurations(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type GetGetConfigurationsByTypeResponse = AxiosResponse<Array<AirportConfiguration>>;
export const KeyGetGetConfigurationsByType = 'GetGetConfigurationsByType';
export const useMutationGetGetConfigurationsByType = (
    options?: UseMutationOptions<
        GetGetConfigurationsByTypeResponse,
        AxiosError,
        AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        GetGetConfigurationsByTypeResponse,
        AxiosError,
        AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest
    >(
        (args: AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getConfigurationsByType(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetConfigurationsByType = (
    args: AirportConfigurationWebServicesApiGetConfigurationsByTypeRequest,
    options?: UseQueryOptions<GetGetConfigurationsByTypeResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetConfigurationsByTypeResponse, AxiosError>(
        [KeyGetGetConfigurationsByType, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getConfigurationsByType(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutSetConfigurationsResponse = AxiosResponse<Array<AirportConfiguration>>;
export const KeyPutSetConfigurations = 'PutSetConfigurations';
export const useMutationPutSetConfigurations = (
    options?: UseMutationOptions<
        PutSetConfigurationsResponse,
        AxiosError,
        AirportConfigurationWebServicesApiSetConfigurationsRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PutSetConfigurationsResponse,
        AxiosError,
        AirportConfigurationWebServicesApiSetConfigurationsRequest
    >(
        (args: AirportConfigurationWebServicesApiSetConfigurationsRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).setConfigurations(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutSetConfigurations = (
    args: AirportConfigurationWebServicesApiSetConfigurationsRequest,
    options?: UseQueryOptions<PutSetConfigurationsResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutSetConfigurationsResponse, AxiosError>(
        [KeyPutSetConfigurations, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).setConfigurations(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export type PutUpdateConfigurationResponse = AxiosResponse<AirportConfiguration>;
export const KeyPutUpdateConfiguration = 'PutUpdateConfiguration';
export const useMutationPutUpdateConfiguration = (
    options?: UseMutationOptions<
        PutUpdateConfigurationResponse,
        AxiosError,
        AirportConfigurationWebServicesApiUpdateConfigurationRequest
    >,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<
        PutUpdateConfigurationResponse,
        AxiosError,
        AirportConfigurationWebServicesApiUpdateConfigurationRequest
    >(
        (args: AirportConfigurationWebServicesApiUpdateConfigurationRequest) =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).updateConfiguration(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryPutUpdateConfiguration = (
    args: AirportConfigurationWebServicesApiUpdateConfigurationRequest,
    options?: UseQueryOptions<PutUpdateConfigurationResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<PutUpdateConfigurationResponse, AxiosError>(
        [KeyPutUpdateConfiguration, args, options && options.queryKey, authQueryKey],
        () =>
            new AirportConfigurationWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).updateConfiguration(args, axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
